export default __webpack_public_path__ + "static/media/rnr-sports-table-3.49277fbc.webp";